'use client';

import React from 'react';
import AppAuthProvider from './AppAuthProvider';

// Firebase is initialized lazily via ui/lib/firebase.ts - no top-level configure call needed.
export default function AuthProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <AppAuthProvider>{children}</AppAuthProvider>;
}
